import { ISwAppSupportedPaymentGateway } from "../interfaces-and-types";

const WEBSITE_URL = "https://www.switchappgo.com";

// will be used by the topup page for initializing top-ups using switchapp-inline.js
export const SWITCHAPP_CHECKOUT_URL =
  process.env.REACT_APP_SWITCHAPP_CHECKOUT_URL;

export const SWITCHAPP_GATEWAY: ISwAppSupportedPaymentGateway = {
  gateway_code: "switchapp",
  gateway_name: "SWITCHAPP",
  gateway_logo_url: "/public/gateway-logos/switchapp.svg",
  gateway_theme_color: "lightblue",
  is_supported: true,
  supports_test_mode: true,
};

export const appConstants = {
  appName: "SwitchApp",
  appCompanyName: "SwitchApp Tech Solutions Ltd",
  appHomepageUrl: process.env.REACT_APP_DASHBOARD_HOMEPAGE_URL,
  appWebsiteUrl: WEBSITE_URL,
  appContactUrl: `${WEBSITE_URL}/contact`,
  appPrivacyUrl: `${WEBSITE_URL}/privacy`,
  cookiePolicyUrl: `${WEBSITE_URL}/cookie-policy`,
  termsAndConditions: `${WEBSITE_URL}/terms-and-conditions`,

  // default country
  DEFAULT_COUNTRY_STATIC: "NG",

  api_keyHeaderName: "x-api-key",
  tenantHeaderName: "x-tenantId",
  isTestModeHeaderName: "x-api-mode",
  sessionIdHeaderName: "x-session-id", // dashboard and API
  checkoutSessionIdHeaderName: "x-checkout-session-id",
};
